import { atom } from 'nanostores';

/**
 * Store for tracking asset upload jobIds that need projectId association
 * These are assets uploaded in the "/" route before projectId is available
 */
export const pendingAssetJobIdsStore = atom<string[]>([]);

/**
 * Add a jobId to the pending list
 */
export function addPendingAssetJobId(jobId: string): void {
  const current = pendingAssetJobIdsStore.get();

  if (!current.includes(jobId)) {
    pendingAssetJobIdsStore.set([...current, jobId]);
    console.log('[pendingAssetJobIdsStore] Added jobId:', jobId);
  }
}

/**
 * Clear all pending jobIds (after successful update)
 */
export function clearPendingAssetJobIds(): void {
  pendingAssetJobIdsStore.set([]);
  console.log('[pendingAssetJobIdsStore] Cleared all pending jobIds');
}

/**
 * Get all pending jobIds
 */
export function getPendingAssetJobIds(): string[] {
  return pendingAssetJobIdsStore.get();
}

/**
 * Remove specific jobIds from pending list
 */
export function removePendingAssetJobIds(jobIds: string[]): void {
  const current = pendingAssetJobIdsStore.get();
  const filtered = current.filter((id) => !jobIds.includes(id));
  pendingAssetJobIdsStore.set(filtered);
  console.log('[pendingAssetJobIdsStore] Removed jobIds:', jobIds);
}
